import axios from "../api";
/** `GET /objectives/groups/:groupId`; 404 `OBJECTIVE_GROUP_NOT_FOUND` for unknown or inactive ids. */
export const getObjectiveGroup = async (groupId) => {
    const res = await axios.get(`/objectives/groups/${groupId}`);
    return res.data;
};
//# sourceMappingURL=getObjectiveGroup.js.map